<template>
  <v-app id="app">
    <Carousel />
    <div>
      <!--CONTENEDOR DE BIENVENIDA-->
      <div class="iniBienvenida">
        <h1>BIENVENIDO A LA FACULTAD DE AGRICULTURA Y ZOOTECNIA</h1>
        <p>
          La Facultad de Agricultura y Zootecnia, comprometida con su entorno
          regional ofrece cursos de actualización a diferentes niveles y en
          diversas áreas. Para mayor informacion contacto nuestro Departamento
          de Vinculación.
        </p>
        <!--El boton te redirije ha la visio y mision de la facultad-->
        <v-btn dark color="black" @click="insertarRuta('/conocenos/mision-vision')">VER MÁS</v-btn>
      </div>
      <!--VIDEO DE PRESENTACION-->
      <div class="iniEstiloInfo">
        <h2 class="text-center">CONVOCATORIA INGRESO SEMESTRE 2025</h2>
        <div class="iniContNovedades">
          <div class="hidden-md-and-up iniImgNovedades">
            <v-img alt="Convocatoria" :src="require('../../assets/img/cartel2025.jpg')" />
          </div>
          <br>
          <div class="my-auto iniInfoNovedades">
            <p>
              <b>Requisitos de ingreso para:</b><br>
            <ul>
              <li>Ingeniero Agrónomo con Especialidad en Fitotecnia (Modalidad: presencial).</li>
              <li>Ingeniero Agrónomo Zootecnista (Modalidad: presencial).</li>
            </ul>
            </p>
            <v-btn dark @click="insertarRuta('/aspirantes/admision')">Más Información</v-btn>
            <br><br>
            <p>
            <ul>
              <li>Ingeniero en Fruticultura (Modalidad: virtual). Esta convocatoria es para ingreso anual, inicia en agosto.
              </li>
            </ul>
            </p>
            <a href="/pdfs/Carta Compromiso.pdf" target="_blank"><v-btn dark>Ingreso Fruticultura</v-btn></a>
            <br>
            <br>
            <v-card elevation="10" class="p-5 mt-5 hidden-sm-and-down">
              <h3>Contactanos</h3>
              <div class="mt-5">
                <v-icon color="red">mdi-email-open</v-icon> academico.faz@ujed.mx
              </div>
              <v-divider></v-divider>
              <div>
                <v-icon color="red">mdi-phone</v-icon> (871) 785-51-70
              </div>
            </v-card>
          </div>
          <div class="hidden-sm-and-down iniImgNovedades"><v-img alt="Convocatoria"
              :src="require('../../assets/img/cartel2025.jpg')"></v-img></div>
        </div>
      </div>
      <!--CONTENEDOR QUE MUESTRA ALGUNAS NOTICIAS Y EVENTOS MAS RELEVANTES-->
      <div class="iniBienvenida">
        <h2 class="text-center">NOTICIAS Y EVENTOS</h2>
        <br>
        <v-row class="mb-5">
          <v-col v-for="item in items" :key="item.id" cols="12" md="4">
            <v-card outlined class="mx-auto" id="iniCardNota">
              <v-img class="white--text align-end" :src="item.src">
                <v-card-title id="iniCardTitle">{{ item.title }}</v-card-title>
              </v-img>
              <div style="text-align: left;">
                <v-card-subtitle class="pb-0">{{ item.subtitle }}</v-card-subtitle>
                <v-card-text class="text--primary">
                  <div>{{ item.description }}</div>
                </v-card-text>
              </div>
              <v-card-actions>
                <v-btn color="primary" text v-bind:href="`${item.link}`" target="_blank">Ver Nota</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <!---->
      <div class="iniEstiloInfo">
        <h2 class="text-center">OFERTA EDUCATIVA</h2>
        <div class="iniContNovedades">
          <div class="iniImgNovedades">
            <v-img alt="Convocatiria 2023" :src="require('../../assets/img/licenciaturas2.jpg')" />
          </div>
          <br>
          <div id="infoNovedades2" class="my-auto">
            <p>
              <b>Licenciaturas</b><br>
              La Facultad de Agricultura y Zootecnia, cuenta con tres programas educativos a nivel licenciatura de los
              cuales dos se encuentran acreditados por COMEAA.
              <br>
              <br>
            <ul>
              <li>Ingeniero Agrónomo con Especialidad en Fitotecnia (Modalidad: presencial).</li>
              <li>Ingeniero Agrónomo Zootecnista (Modalidad: presencial).</li>
              <li>Ingeniero en Fruticultura (Modalidad: virtual). </li>
            </ul>
            </p>
            <v-btn dark @click="insertarRuta('/licenciaturas')">Más Información</v-btn>
          </div>
        </div>
      </div>
      <div class="iniEstiloInfo">
        <div class="iniContNovedades">
          <div class="hidden-md-and-up iniImgNovedades">
            <v-img alt="Convocatiria 2023" :src="require('../../assets/img/posgrados2.jpg')" />
          </div>
          <br>
          <div class="my-auto iniInfoNovedades">
            <p>
              <b>Posgrado</b><br>
              La Facultad de Agricultura y Zootecnia, cuenta con una maestría en el padrón de Conacyt y tres doctorados de
              los cuales dos se encuentra en el padrón de Conacyt.
              <br>
              <br>
            <ul>
              <li>Maestría en Ciencias en "Agricultura Orgánica Sustentable (PNPC-CONACYT).</li>
              <li>Doctorado en Ciencias en "Manejo Sustentable de los Recursos Naturales en Zonas Áridas y Semiáridas".
              </li>
              <li>Doctorado Interinstitucional en Ciencias en Sustentabilidad de los Recursos Agropecuarios
                (PNPC-CONACYT).</li>
            </ul>
            </p>
            <v-btn dark @click="irPosgrado()">Más Información</v-btn>
          </div>
          <div class="hidden-sm-and-down iniImgNovedades"><v-img alt="Convocatoria 2023"
              :src="require('../../assets/img/posgrados2.jpg')"></v-img></div>
        </div>
      </div>
    </div>
  </v-app>
</template>
<script>
import Carousel from './Carousel';

export default {
  name: 'PagInicio',
  data() {
    return {
      //Objeto que contiene las notcias a mostrar, aqui se puede cambiar el titulo, la imagen y la dirreccion para ver mas informacion
      datosNoticias: [
        {
          id: 1,
          title: 'Nuevos integrantes del SNI',
          src: require('../../assets/img/15demayo.jpg'),
                  
        },
        {
          id: 2,
          title: 'Concurso Canto Popular',
          src: require('../../assets/img/diamadres.jpg'),
          link: 'https://www.facebook.com/UJEDFAZ/posts/pfbid02igRdNwj3aMuBCEAKMrALvQmEtvBMYu8RruQvzAkfpjcXgpuzhbt7awVQTen8qi9Tl?__cft__[0]=AZUeKjblew_ovHAcaKUhely8sOO9XE4FIDHEq6KP2FlREc8SK-BTWBIcP6CDKpKsmHTaT2bY9Hasn96eXat4bbtrlbA2rNTavCbQSM7QbGQRN1udH40UR0Pj1PpQYUrDiBtiG1AR8Bdb1CpX4VIfS6S1cj7FaRdFqtlBCzyYv5C7dvjVT0Mxh2eQxeVw7QA4vSzxdes5vU3uCB4HAq0AV5Ze&__tn__=%2CO%2CP-R'
        },
        {
          id: 3,
          title: '50 Aniversario de la FAZ',
          src: require('../../assets/img/diamujer.jpg'),
          link: 'https://www.facebook.com/UJEDFAZ/posts/pfbid0VcWSBemJ88JBADoYnMJpXqBAh4otaGwJMpsGsLQXvqL4bzZfAdQmp5y5jNUjFZpNl?__cft__[0]=AZXVJ9owZB2pJ1e5BKDZv99f54mORppzjNPbUKD_MvkL8s7uECh6TVI_rbQUh6uNTsay2jrq1VtyxF9_YRbgGxNUozbr5xxjP1bs_LSv4rl4URK8ip7R1Mxdqj_sE8I-blUHXP-fCJrH0E-g_OXPzSijNDEPNtAGuBSid9cY9PdMIOCuxRH1ikqU8lMGgYoMMt8Z_05ZH0uYlBGM-XHY-cvJ&__tn__=%2CO%2CP-R'
        },
        {
          id: 3,
          title: '50 Aniversario de la FAZ',
          src: require('../../assets/img/diamujer.jpg'),
          link: 'https://www.facebook.com/UJEDFAZ/posts/pfbid0VcWSBemJ88JBADoYnMJpXqBAh4otaGwJMpsGsLQXvqL4bzZfAdQmp5y5jNUjFZpNl?__cft__[0]=AZXVJ9owZB2pJ1e5BKDZv99f54mORppzjNPbUKD_MvkL8s7uECh6TVI_rbQUh6uNTsay2jrq1VtyxF9_YRbgGxNUozbr5xxjP1bs_LSv4rl4URK8ip7R1Mxdqj_sE8I-blUHXP-fCJrH0E-g_OXPzSijNDEPNtAGuBSid9cY9PdMIOCuxRH1ikqU8lMGgYoMMt8Z_05ZH0uYlBGM-XHY-cvJ&__tn__=%2CO%2CP-R'
        },
      ],
      //Objeto que contiene la informacion que se muestra en el apartado de Oferta Educativa (los accesos directos)
      datosOE: [
        {
          img: require('../../assets/img/licenciaturas.jpg'),
          title: 'Licenciaturas',
          texto:
            'La Facultad de Agricultura y Zootecnia, cuenta con tres programas educativos a nivel licenciatura de los cuales dos se encuentran acreditados por COMEAA.',
          ruta: '/licenciaturas'
        },
        {
          img: require('../../assets/img/posgrados.jpg'),
          title: 'Posgrados',
          texto:
            'La Facultad de Agricultura y Zootecnia, cuenta con una maestría en el padrón de Conacyt y tres doctorados de los cuales dos se encuentra en el padrón de Conacyt.',
          ruta: '/posgrados'
        },
      ],
      items: [
        {
          id: 1,
          title: "Adquiere tu ficha 2025",
          subtitle: "Nuevo ingreso",
          description: "",
          src: "https://scontent.ftrc2-1.fna.fbcdn.net/v/t39.30808-6/480524675_1024196403087015_8460832481449875526_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=833d8c&_nc_ohc=cTBQ0U64juAQ7kNvgHFsoqC&_nc_oc=AdiJJ3J_ByPCMyIzbGg_95G63M_GRgYTvrvarxObygXS2PtKHLp8oq1SAkDZ8qbVguw&_nc_zt=23&_nc_ht=scontent.ftrc2-1.fna&_nc_gid=AN9bS3vdgkR1BPZbzLxn3VT&oh=00_AYAY4b2eK-EkTVUt8nKQIwpKzyJ5PWuBctfJz3mA7S-ptA&oe=67B8038F",
          link: "https://www.facebook.com/share/p/1Cg4btejZN/"           
        },
        {
          id: 2,
          title: "Día del amor y la amistad",
          subtitle: "14 de febrero 2025",
          description: "",
          src: 'https://scontent.ftrc2-1.fna.fbcdn.net/v/t39.30808-6/480202592_1023555486484440_2225602491095706988_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=833d8c&_nc_ohc=eI0zcVQRnfkQ7kNvgGSPGtu&_nc_oc=Adh438k_uV2wyZA9yV6pLXeBaghsyTttLA-G_Z7iXaZ-X-dSmSxN5DN-LngY2dVwpoc&_nc_zt=23&_nc_ht=scontent.ftrc2-1.fna&_nc_gid=Abl48n_b3ekBg_7I-cEtdCM&oh=00_AYB3JwtrD8mPAeAWmXRTc1yFnxsaWejY_1NCCDnumP1jAw&oe=67B813CE', 
          link: "https://www.facebook.com/share/p/15jsTAAbS5/"
        },
        {
          id: 3,
          title: "Curso opción tesis 2025",
          subtitle: "Opción de titulación",
          description: "",
          src: 'https://scontent.ftrc2-1.fna.fbcdn.net/v/t39.30808-6/476837796_1021027323403923_5820482299537458703_n.jpg?_nc_cat=104&ccb=1-7&_nc_sid=833d8c&_nc_ohc=qh0cVj6TacQQ7kNvgHywINN&_nc_oc=Adg3DWcp9_C6a6hRmNvCDgAsuQpiWWRFbndascshqVyaMsMWznWPi1LKx32UnaoVEr0&_nc_zt=23&_nc_ht=scontent.ftrc2-1.fna&_nc_gid=AMOSBKXWrzJSYalQk7_xsyC&oh=00_AYAQfchtq8W_EaNof0fsksqW9ERn_hUGg-o86aogMQPUig&oe=67B7FC2B', 
          link: "https://www.facebook.com/share/p/15frfFkpQM/"
        }
      ]
    };
  },
  //METODOS UTILIZADOS
  methods: {
    //Se utiliza para navegar por diferentes rutas (redirrecciona hacia otra pagina)
    insertarRuta(ruta) {
      this.$router.push(ruta);
    },
    //Ir a la pagina de posgrados FAZ
    irPosgrado() {
      location.replace(window.location.protocol + "//" + window.location.host + "/Posgrado/");
    },    
  },
  components: { Carousel },
};
</script>
